import React from 'react'
import { LeadCard } from '@marketing-milk/interfaces'

type Props = {
  form: LeadCard
  onRemove: () => void
}

export const LeadFormChip = ({ form, onRemove }: Props) => (
  <div className="flex items-center gap-2 rounded-full border border-purple-300 bg-purple-50 pl-3 pr-2 py-1.5 text-sm font-medium text-purple-800">
    <span>{form.formName}</span>
    <button
      type="button"
      onClick={onRemove}
      aria-label={`Remove ${form.formName}`}
      className="flex items-center justify-center w-4 h-4 rounded-full text-purple-500 hover:text-purple-900 hover:bg-purple-200 leading-none"
    >
      ×
    </button>
  </div>
)
